/**
 * @author Fernando Ruano
 * @file actions.js
 * @description Patient Appointments Actions
 */

// Constants
import {
  GET_ALL_PATIENT_APPOINTMENTS,
  CREATE_PATIENT_APPOINTMENTS,
  GET_APPOINTMENT_AVAILABILITIES,
  RESCHEDULE_PATIENT_APPOINTMENTS,
  CANCEL_PATIENT_APPOINTMENTS,
  GET_AGENDA_MATE_PATIENT
} from './constants';

/**
 * Call process to get all patient appointments list
 * @param  { object } data - Patient Appointments Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_ALL_PATIENT_APPOINTMENTS
 */
export const getPatientAppointmentsArray = (data, callback) => ({
  type: GET_ALL_PATIENT_APPOINTMENTS,
  payload: { data },
  callback
});

/**
 * Call process to create patient appointments
 * @param  { object } data - Patient Appointments Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CREATE_PATIENT_APPOINTMENTS
 */
export const createPatientAppointments = (data, callback) => ({
  type: CREATE_PATIENT_APPOINTMENTS,
  payload: { data },
  callback
});

/**
 * Call process to get staff appointment availabilities
 * @param  { object } data - Appointment availabilities Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_APPOINTMENT_AVAILABILITIES
 */
export const getAppointmentAvailabilities = (data, callback) => ({
  type: GET_APPOINTMENT_AVAILABILITIES,
  payload: { data },
  callback
});

/**
 * Call process to reschedule patient appointments
 * @param  { object } data - Patient Appointments Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of RESCHEDULE_PATIENT_APPOINTMENTS
 */
export const reSchedulePatientAppointments = (data, callback) => ({
  type: RESCHEDULE_PATIENT_APPOINTMENTS,
  payload: { data },
  callback
});

/**
 * Call process to cancel patient appointments
 * @param  { object } data - Patient Appointments Data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of CANCEL_PATIENT_APPOINTMENTS
 */
export const cancelPatientAppointments = (data, callback) => ({
  type: CANCEL_PATIENT_APPOINTMENTS,
  payload: { data },
  callback
});

/**
 * Call process to get agenda mate patient info
 * @param  { object } data - AgendaMate Patient  info
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_AGENDA_MATE_PATIENT
 */
export const getAgendaMatePatient = (data, callback) => ({
  type: GET_AGENDA_MATE_PATIENT,
  payload: { data },
  callback
});
